export default {"src":"/_next/static/media/Facebook-Icon.31fac2ad.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};